export const feedbackFormLinks = {
  en: "https://docs.google.com/forms/d/e/1FAIpQLScgZgh_kQRK_TlPnBb4T4DaVjitRksKyKE1NoXt7troi1I3cA/viewform",
  ee: "https://docs.google.com/forms/d/e/1FAIpQLSc5cu5-TDde21IFDjQLfWPS6YCz9yR9W82Yuof_mTrCltPRIw/viewform?usp=sf_link",
};

export const subscribeForm = {
  url: "https://docs.google.com/forms/d/e/1FAIpQLSdnhhACc8nCilJsm3BVwgK99GIcry1dhojULLWUSTupIDqmuw/formResponse?&submit=Submit",
  fields: {
    name: "entry.1447878993",
    email: "entry.159945679",
  },
};
